export default __webpack_public_path__ + "static/media/732.5280f3ac.png";